// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const navigationModule = require('../modules/navigation');

// CSS
require('../../css/legal.css');


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();
